import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

type TypeOptions = 'success' | 'error' | 'warning' | 'info' | 'default'

export const showToast = (message: string, timeout: number, type: TypeOptions) => {
  toast(message, {
    position: 'top-right',
    autoClose: timeout,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: type,
  })
}
